<!--  -->
<template>
  <div class="monitor">
    <div class="title" style="width:47%">
      <div class="title-text">重点监控</div>
    </div>
    <div class="content">
      <div class="item">
        <div class="jksp">
          <video ref="video3" src="../../assets/video/1.mp4" muted loop autoplay></video>
        </div>
        <div>监控-01</div>
        <div>
          <p>{{nowDate}} {{nowTime}} {{nowWeek}} </p>
          <!-- <span>{{nowDate}}</span>
          <span>{{nowTime}}</span>
          <span>{{nowWeek}}</span> -->
        </div>
      </div>
      <div class="item">
        <div class="jksp">
          <video ref="video3" src="../../assets/video/3.mp4" muted loop autoplay></video>
        </div>
        <div>监控-02</div>
        <div>
          <p>{{nowDate}} {{nowTime}} {{nowWeek}} </p>
          <!-- <span>{{nowDate}}</span>
          <span>{{nowTime}}</span>
          <span>{{nowWeek}}</span> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      nowTime: "", //当前时间，时，分，秒 23:23:23
      nowDate: "", //当前日期
      nowWeek: "", //当前星期
    };
  },

  components: {},
created() {
    this.getTime();
    setInterval(this.getTime, 500);
  },
  computed: {},

  methods: {
    //时间格式转换
    covert(arg) {
      return arg < 10 ? "0" + arg : arg;
    },
    getTime() {
      let date = new Date(); //获取当前日期信息
      let year = date.getFullYear(); //获取当前年
      let month = date.getMonth() + 1; //获取当前月
      let day = date.getDate(); //获取当前天
      let week = date.getDay(); //获取星期
      let hour = date.getHours(); //获取当前小时
      let minutes = date.getMinutes(); //获取当前分
      let seconds = date.getSeconds(); //获取当前小时
      
      this.nowDate = year + "-" + this.covert(month) + "-" + this.covert(day);
this.nowTime =
        this.covert(hour) +
        ":" +
        this.covert(minutes) +
        ":" +
        this.covert(seconds);

      const weeks = new Array(
        "周日",
        "周一",
        "周二",
        "周三",
        "周四",
        "周五",
        "周六"
      );
      this.nowWeek = weeks[week];
    },
  }

};
</script>
<style lang="less" scoped>
.monitor {
  // width: 534px;
  position: relative;
  left: 9%;
  .content {
    width: 100%;
    margin-top: 1vh;
    height: 17vh;
    display: flex;
    .item {
      font-family: sy;
      justify-content: space-between;
    font-size: 12px;
    
    color: rgb(255, 255, 255);
    margin-right: 30px;
      .jksp {
        // background: url(../../assets/jksp.png);
        // background-repeat: no-repeat;
        // background-size: 100% 100%;
        width: 100%;
    height: 63%;
    display: flex;
    justify-content: space-between;
        video{
          width: 100%;
          height: 100%;
        }
      }
      div {
        &:nth-child(2) {
          margin-top: 1vh;
          color: #fff;
          font-size: 0.9vh;
        }
        &:nth-child(3) {
          margin-top: 0.5vh;
          color: #fff;
          font-size: 0.9vh;
        }
      }
    }
  }
}
</style>